import { Type } from '../interfaces/IPipelineOutput';
import { ISelectOption } from '../interfaces/ISelectOption';

export type SnowflakeAdditionalPropertiesKeyType = 'schema' | 'useUtcTimestamps';

export const snowflakeAdditionalPropertiesAdapts = {
    schema: '*',
    useUtcTimestamps: '*'
};

export const snowflakeAdditionalFieldsKeyOptions: Array<ISelectOption<SnowflakeAdditionalPropertiesKeyType>> = [
    {
        label: 'Schema',
        value: 'schema' as SnowflakeAdditionalPropertiesKeyType,
        type: Type.String
    },
    {
        label: 'UseUtcTimestamps',
        value: 'useUtcTimestamps' as SnowflakeAdditionalPropertiesKeyType,
        hide: `{ version !== '1.1'}`,
        type: Type.Boolean
    }
];

export const snowflakeAdditionalFieldsAllowedKeys: SnowflakeAdditionalPropertiesKeyType[] = snowflakeAdditionalFieldsKeyOptions.map((option) => option.value);
